require('./_set-species')('Array');



//////////////////
// WEBPACK FOOTER
// ../~/core-js/modules/es6.array.species.js
// module id = 415
// module chunks = 0